import 'intersection-observer'

// TODO: Replace all body-scroll-locks to scroll-lock and then remove the first from the list
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollActive from 'vue-scrollactive'
import TailwindCssSelectors from '@/components/TailwindCssSelectors.vue'

import '@/app.css'

// Components
import parallaxScroll from '@/components/ParallaxScoll'
import buttonRipple from '@/components/ButtonRipple'
import heroSlider from '@/components/HeroSlider'
import fadeInText from '@/components/FadeInAnimation'
import GtmTracking from '@/components/GtmTracking'
import CampaignTracking from '@/components/CampaignTracking'
import accordion from '@/components/Accordion'
import chatbot from '@/components/ChatBot'
import formHandler from '@/components/handlers/form-handler'

import AdimoButton from '@/components/AdimoButton.vue'
import Picture from '@/components/Picture.vue'
import MainMenu from '@/components/MainMenu.vue'
import Slider from '@/components/Slider.vue'
import VideoOverlayTrigger from '@/components/VideoOverlayTrigger.vue'
import VideoOverlay from '@/components/VideoOverlay.vue'
import MediaBlock from '@/components/MediaBlock.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import YoutubeVideo from '@/components/YoutubeVideo.vue'
import Video from '@/components/Video.vue'
import InvisibleRecaptchaElement from '@/components/formElements/InvisibleRecaptchaElement.vue'

import RecipeIngredients from '@/components/recipes/RecipeIngredients.vue'
import ServingSuggestions from '@/components/ServingSuggestions.vue'
import RecipeCookMode from '@/components/recipes/RecipeCookMode.vue'

import SubNavigation from '@/components/SubNavigation.vue'
import AnchorNavBar from '@/components/AnchorNavBar.vue'

import ProductsOverview from '@/components/products/ProductsOverview.vue'
import FacetComponents from '@/components/facet'
import vueUtil from '@/vue-utils'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueScrollActive)

const components = {
  AdimoButton,
  Picture,
  MainMenu,
  Slider,
  VideoOverlayTrigger,
  VideoOverlay,
  MediaBlock,
  CookieBanner,
  RecipeIngredients,
  RecipeCookMode,
  ServingSuggestions,
  ProductsOverview,
  YoutubeVideo,
  ...FacetComponents,
  Video,
  InvisibleRecaptchaElement,
  TailwindCssSelectors,
  SubNavigation,
  AnchorNavBar
}

vueUtil.mountComponents(components)

// Init scripts
buttonRipple()
parallaxScroll()
heroSlider()
fadeInText('.animated-item')
GtmTracking()
CampaignTracking()
accordion('.c-faq-opener', {
  dataLayerEvent: (el, state) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'faqClick',
        interactionType: `accordion_${state}`
      })
    }
  }
})

accordion('.c-tip-opener', {
  dataLayerEvent: (el, state) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'tipClick',
        eventAction: state,
        tipName: el.innerText.trim()
      })
    }
  }
})
chatbot()
window.addEventListener('DOMContentLoaded', () => {
  formHandler.init()
})
